<template>
  <div>
    <el-dialog
      title="Export"
      :visible.sync="shouldShow"
      @close="closeEvent"
      width="30%"
    >
      <eden-file-export
        :data="exportData"
        @exported="closeEvent"
        @cancelled="closeEvent"
      >
        <el-form label-position="top" :model="form">
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item label="Select the data you'd like to export">
                <el-checkbox-group v-model="form.fields">
                  <el-checkbox
                    v-for="(value, key, i) in fields"
                    :key="i"
                    :disabled="key === 'name' || key === 'email'"
                    :label="key"
                  >
                    {{ value }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item label="Select data format">
                <el-radio-group v-model="form.format">
                  <el-radio
                    v-for="(key, value, i) in formats"
                    :key="i"
                    :label="value"
                  >
                    {{ key }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="is-flex justify-end">
          <el-button
            type="primary"
            :loading="exporting"
            @click="getExportData"
            :disabled="!form.format || !form.fields.length"
            >Export</el-button
          >
        </div>
      </eden-file-export>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GardenerCustomersExport",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      fields: {
        name: "Name",
        email: "Email",
        status: "Status",
        services: "Services",
        amount: "Subscription Amount",
        billing_date: "Billing Date",
      },
      formats: {
        pdf: "PDF",
        csv: "CSV",
        xls: "Excel",
      },
      form: {
        fields: ["name", "email"],
        format: "",
      },
      exportData: {},
      exporting: false,
    };
  },
  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  watch: {
    exporting() {
      if (!this.exporting) {
        this.closeEvent();
      }
    },
  },
  methods: {
    closeEvent() {
      this.form.fields = ["name", "email"];
      this.form.format = "";
      this.exporting = false;
      this.shouldShow = false;
    },

    getExportData() {
      this.loading = true;
      this.formatExportData(this.data);
      this.mixpanelTrack({
        event: "gardener_customers_export",
      });
    },

    formatExportData(data) {
      let title;
      let date = this.formatDateAndTime(new Date(), "do m, y");
      let gardener = data[0].gardener;
      title = `Gardener's Customers (${gardener}): Exported at - ${date}`;

      let headers = {
        sn: "S/N",
      };
      let extra_headers = {};
      let gardenerCustomersData = [];
      this.form.fields.forEach(
        (key) => (extra_headers[key] = this.fields[key])
      );
      headers = { ...headers, ...extra_headers };
      gardenerCustomersData = data.map((item, index) => {
        let export_object = {};
        Object.keys(headers).forEach((key) => {
          switch (key) {
            case "sn":
              export_object[key] = index + 1;
              break;
            case "name":
              export_object[key] = this.formatName(item.name);
              break;
            case "email":
              export_object[key] = item.email;
              break;
            case "status":
              export_object[key] = item.status;
              break;
            case "services":
              export_object[key] = item.services.map((item_service) => {
                return item_service;
              });
              break;
            case "amount":
              this.form.format === "pdf"
                ? (export_object[key] = this.formatPdfPrice(
                    item.subscription_amount
                  ))
                : (export_object[key] = this.formatPrice(
                    item.subscription_amount
                  ));
              break;
            case "billing_date":
              export_object[key] = this.formatDate(
                item.subscription_due,
                "dddd do, m, y"
              );
              break;
            default:
              break;
          }
        });
        return export_object;
      });
      this.exportData = {
        title,
        headers,
        data: gardenerCustomersData,
        fileName: `Gardener Customers List - ${gardener}`,
        titleMargin: 44,
        format: this.form.format,
      };
      this.exporting = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
